<script>
    export default {
        name: 'newsletter-form',
        data() {
            return {
                loading: false,
                success: false,
                error: false,
                email: null
            }
        },
        methods: {
            onSubmit(list) {
                let vm = this;
                vm.loading = true;
                vm.success = false;
                vm.error = false;

                $.getJSON("/apsis/newsletter", {
                    email: vm.email,
                    list: list
                })
                    .then(response => {
                      console.log(response)
                        if (response.hasOwnProperty('error')) {
                            vm.success = false;
                            vm.error = true;
                        } else {
                            vm.success = true;
                            vm.error = false;
                        }

                        vm.loading = false;
                    });
            }
        }
    }
</script>
